import React from "react";
// import "./trafficmethod.css";
import { Container } from "react-bootstrap";
import { Link} from "react-router-dom";
const CarMethod = ({ userData }) => {
  return (
    <Container>
      <div className="paymentmethod">
        <div className="naqdi">
          {" "}
          <Link to={"/user/car/extractlec"} className="mainb">
            استخراج رخصة <i className="fa-solid fa-address-card"></i>
          </Link>
        </div>
        <div className="naqdi">
          {" "}
          <Link to="/user/car/newlec" className="mainb">
            تجديد رخصة <i className="fa-solid fa-address-card"></i>
          </Link>
        </div>
        <div className="banqi">
          {" "}
          <Link to="/user/car/faqedlec" className="mainb">
            بدل فاقد <i className="fa-solid fa-file-contract"></i>
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default CarMethod;
